import { toast } from "react-toastify";
import NProgress from "nprogress";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_FINANCE_API_URL } from "../../../Constants/baseConstant";
import { ConvertDate, getDomain, getEmployeeId, getUserData, getUserId } from "../../Base/helper/baseFunctions";
import { sendExpenseEmailHelper } from "./HelperComponents/ExpenseMailHelper"
export const GetEmployeeExpenseHelper = async (params) => {
  NProgress.start();
  return await axiosInstance(`/finance/getEmployeeExpense`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      employee_fk: getEmployeeId(),
    },
  })
    .then((res) => {
      NProgress.done();
      return {
        message: "Expense retrieved successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      NProgress.done();
      return {
        message: "Unable to retrieve expense",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const AddEmployeeExpenseHelper = async (params) => {
  toast.dismiss();
  toast.info("Saving...");
  return await axiosInstance(`/finance/addEmployeeExpense`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      employee_fk: getEmployeeId(),
      sub_expense_type_fk: params?.sub_expense_type_fk,
      amount: params?.amount,
      status: params?.employee_status,
      finance_approver_status: params?.finance_approver_status,
      date: params?.date,
      proof: params?.proof || "",
      b64string: params?.b64string || "",
      content_type: params?.content_type || "",
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Expense added successfully");
      if(params?.isApprovalReq) {
      sendExpenseEmailHelper({
        status: "Submitted",
        toEmail: params?.approver_email,
        managerName: params?.approverName,
        category: params?.category,
        subCategory: params?.subCategory,
        claimedAmount: params?.amount,
        company_logo: params?.company_logo,
        employeeName: getUserData()?.name,
        date: ConvertDate(params?.date)
      })
      }
      return {
        message: "Expense added successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to add expense",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const UpdateEmployeeExpenseHelper = async (params) => {
  toast.dismiss();
  toast.info("Saving...");
  return await axiosInstance(`/finance/updateEmployeeExpense`, {
    method: "PUT",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      employee_expense_fk: params?.employee_expenses_pk,
      sub_expense_type_fk: params?.sub_expense_type_fk,
      amount: params?.amount,
      status: params?.employee_status,
      finance_approver_status: params?.finance_approver_status,
      date: params?.date,
      proof: params?.proof,
      b64string: params?.b64string || "",
      content_type: params?.content_type || "",
      old_proof: params?.old_proof || ""
    },
  })
    .then((res) => {
      sendExpenseEmailHelper({
        status: "ReSubmitted",
        toEmail: params?.approver_email,
        managerName: params?.approverName,
        category: params?.category,
        subCategory: params?.subCategory,
        claimedAmount: params?.amount,
        company_logo: params?.company_logo,
        employeeName: getUserData()?.name,
        date: ConvertDate(params?.date)
      })
      toast.dismiss();
      toast.success("Expense updated successfully");
      return {
        message: "Expense updated successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to update expense",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const DeleteEmployeeExpenseHelper = async (params) => {
  toast.dismiss();
  toast.info("Deleting...");
  return await axiosInstance(`/finance/deleteEmployeeExpense`, {
    method: "DELETE",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      employee_expense_fk: params?.employee_expenses_pk,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Expense deleted successfully");
      return {
        message: "Expense deleted successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to delete employee expense",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

// approver

export const GetApproverExpenseHelper = async (params) => {
  NProgress.start();
  return await axiosInstance(`/finance/getApproverExpense`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      employee_fk: getEmployeeId(),
    },
  })
    .then((res) => {
      NProgress.done();
      return {
        message: "Employee expense retrieved successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      NProgress.done();
      return {
        message: "Unable to retrieve employee expense",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const UpdateApproverExpenseHelper = async (params) => {
  toast.dismiss();
  toast.info("Saving...");
  return await axiosInstance(`/finance/updateApproverExpense`, {
    method: "PUT",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: params?.user_id ? params?.user_id : getUserId(),
      employee_expense_fk: params?.employee_expenses_pk,
      finance_approver_amount: params?.finance_approver_amount,
      finance_approver_status: params?.finance_approver_status,
      employee_status: params?.employee_status,
      approver_comment: params?.approver_comment || ""
    },
  })
    .then((res) => {
      if(!params?.employee_side) {
        sendExpenseEmailHelper({
          status: params?.finance_approver_status,
          toEmail: params?.employeeEmail,
          employeeName: params?.employeeName,
          category: params?.category,
          subCategory: params?.subCategory,
          claimedAmount: params?.claimedAmount,
          approverAmount: params?.finance_approver_amount,
          company_logo: params?.company_logo
        })
        toast.dismiss();
        toast.success("Employee expense updated successfully");
      }
      return {
        message: "Employee expense updated successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to update employee expense",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

// expense report
export const GetExpenseReportHelper = async (params) => {
  return await axiosInstance(`/finance/getEmployeeExpenseReport`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      employee_fk: params?.employee_fk,
      month: params?.month,
      year: params?.year
    },
  })
    .then((res) => {
      return {
        message: "Employee expense retrieved successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to retrieve employee expense",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const GetExpenseCsvHelper = async (params) => {
  NProgress.start();
  return await axiosInstance(`/finance/getEmployeeExpenseCsv`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      employee_fk: null,
      month: params?.month,
      year: params?.year
    },
  })
    .then((res) => {
      NProgress.done();
      return {
        message: "Employee expense csv retrieved successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      NProgress.done();
      return {
        message: "Unable to retrieve csv employee expense",
        hasError: true,
        data: err?.response?.data,
      };
    });
};